import { useState } from "react";
import { Palmtree } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

function authFetch(url, opts = {}) {
  const token = localStorage.getItem("token");
  return fetch(url, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", ...(opts.headers || {}) },
  });
}

export default function VacationPlanModal({ open, onOpenChange, selectedUserId, activeYear, onSuccess }) {
  const [vacPlanFrom, setVacPlanFrom] = useState("");
  const [vacPlanTo, setVacPlanTo] = useState("");
  const [vacPlanning, setVacPlanning] = useState(false);

  const handleSave = async () => {
    setVacPlanning(true);
    try {
      const res = await authFetch(`${API}/vacation/plan`, {
        method: "POST",
        body: JSON.stringify({
          employee_id: selectedUserId,
          from_date: vacPlanFrom,
          to_date: vacPlanTo,
        }),
      });
      if (res.ok) {
        const data = await res.json();
        toast.success(`${data.days_planned || 0} Urlaubstage geplant!`);
        onOpenChange(false);
        setVacPlanFrom("");
        setVacPlanTo("");
        if (onSuccess) onSuccess();
      } else {
        const err = await res.json();
        toast.error(err.detail || "Fehler beim Planen");
      }
    } catch {
      toast.error("Fehler beim Planen");
    }
    setVacPlanning(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[15px]">
            <Palmtree className="w-4 h-4 text-green-600" /> Urlaub planen
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div>
            <Label className="text-[12px] text-gray-600">Von</Label>
            <Input type="date" value={vacPlanFrom} onChange={(e) => setVacPlanFrom(e.target.value)} className="h-9 text-[13px]" data-testid="vac-plan-from" />
          </div>
          <div>
            <Label className="text-[12px] text-gray-600">Bis</Label>
            <Input type="date" value={vacPlanTo} onChange={(e) => setVacPlanTo(e.target.value)} className="h-9 text-[13px]" data-testid="vac-plan-to" />
          </div>
          {vacPlanFrom && vacPlanTo && vacPlanFrom <= vacPlanTo && (
            <div className="text-[12px] text-gray-500 bg-gray-50 px-3 py-2 rounded-md" data-testid="vac-plan-days-info">
              {(() => {
                let days = 0;
                const from = new Date(vacPlanFrom);
                const to = new Date(vacPlanTo);
                for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
                  if (d.getDay() !== 0 && d.getDay() !== 6) days++;
                }
                return <span>{days} Arbeitstag(e) Urlaub</span>;
              })()}
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" size="sm" className="text-[12px]" onClick={() => onOpenChange(false)}>Abbrechen</Button>
          <Button
            size="sm"
            className="text-[12px] bg-green-600 hover:bg-green-700"
            disabled={vacPlanning || !vacPlanFrom || !vacPlanTo || vacPlanFrom > vacPlanTo}
            onClick={handleSave}
            data-testid="vac-plan-save-btn"
          >
            {vacPlanning ? "Speichern..." : "Urlaub eintragen"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
